export default {
    general: {
        add:            'Dodaj',
        edit:           'Uredi',
        cancel:         'Prekliči',
        save:           'Shrani',
        close:          'Zapri',
        delete:         'Izbriši',
        confirm:        'Potrdi',
        yes:            'Da',
        no:             'Ne',
        search:         'Iskanje',
        refresh:        'Osveži',
        retry:          'Poskusi znova',
        back:           'Nazaj',
        copy:           'Kopiraj',
        copied:         'Kopirano v odložišče',
        download:       'Prenesi',
        open:           'Odpri',
        none:           'Brez',
        all:            'Vse',
        never:          'Nikoli',
        unknown:        'Neznano',
        actions:        'Dejanja',
        name:           'Ime',
        status:         'Stanje',
        loading:        'Nalaganje…',
        no_data:        'Ni podatkov',
        apply:          'Uporabi',
        clear:          'Počisti',
        enabled:        'Vklopljeno',
        disabled:       'Izklopljeno',
        days:           'dni',
        hours:          'ur',
        user:           'Uporabnik',
        users:          'Uporabniki',
        project:        'Projekt',
        created:        'Ustvarjeno',
        updated:        'Posodobljeno',
        details:        'Podrobnosti',
        optional:       'neobvezno',
        of:             'od',
    },
    errors: {
        generic_error:         'Nekaj je šlo narobe',
        invalid_data:          'Nekateri podatki niso pravilni',
        not_found:             'To ni več na voljo',
        unauthorized:          'Niste prijavljeni',
        forbidden:             'Za to dejanje nimate pravic',
        conflict:              'Tega zdaj ni mogoče narediti — osvežite stran in poskusite znova',
        no_capacity:           'Na strežniku trenutno ni prostora za novo delovno okolje',
        upstream_failure:      'Storitev, ki jo Startbox potrebuje, se ni odzvala — poskusite znova čez trenutek',
        incus_unavailable:     'Strežnik trenutno ni pripravljen — poskusite znova čez trenutek',
        gone:                  'Ta povezava ni več na voljo',
        no_hostname_available: 'Trenutno ni prostega spletnega naslova — poskusite znova čez nekaj minut',
        instance_type_limit:   'Že poganjate največje dovoljeno število delovnih prostorov te vrste.',
        image_preparing:       'Slika delovnega prostora se pripravlja — to traja nekaj minut.',
        kvm_unavailable:       'Ta velikost delovnega prostora potrebuje virtualizacijo, ki je ta strežnik nima.',
        failed_to_insert:      'Shranjevanje ni uspelo',
        on_add:                'Dodajanje ni uspelo',
        on_edit:               'Shranjevanje ni uspelo',
        on_delete:             'Brisanje ni uspelo',
        on_load:               'Nalaganje ni uspelo',
        rate_limited:          'Preveč poskusov — počakajte trenutek in poskusite znova',
        // Ena preprosta poved za vsak `state_reason` (tehnični načrt §3.3).
        state: {
            incus_unavailable: 'Strežnik trenutno ni pripravljen. Poskusite znova čez trenutek.',
            image_unavailable: 'Slika delovnega prostora trenutno ni na voljo.',
            no_capacity:       'Na strežniku trenutno ni prostora za ta delovni prostor.',
            timeout:           'Postopek je trajal predolgo in je bil ustavljen. Poskusite znova.',
            volume_failed:     'Shrambe delovnega prostora ni bilo mogoče pripraviti.',
            create_failed:     'Delovnega prostora ni bilo mogoče ustvariti. Poskusite znova.',
            config_failed:     'Delovnega prostora ni bilo mogoče nastaviti. Poskusite znova.',
            netbird_failed:    'Zasebno omrežje tega delovnega prostora ni sprejelo.',
            start_failed:      'Delovni prostor se ni zagnal. Poskusite znova.',
            stop_failed:       'Delovnega prostora ni bilo mogoče ustaviti.',
            delete_failed:     'Delovnega prostora ni bilo mogoče izbrisati.',
            disk_pressure:     'Ustavljen, ker je na strežniku zmanjkalo prostora na disku.',
            unknown:           'Zagon ni uspel. Poskusite znova.',
        },
    },
    success: {
        add:    'Uspešno dodano',
        edit:   'Uspešno posodobljeno',
    },
    validation: {
        required:    'To polje je obvezno',
        email:       'Neveljaven e-poštni naslov',
        signin_code: 'Prilepite kodo, ki vam jo je pokazal Claude, brez presledkov',
        min_search:  'Vnesite vsaj 2 znaka',
        positive:    'Vrednost mora biti večja od nič',
    },
    app: {
        name:    'Startbox',
    },
    layout: {
        open_menu:  'Odpri meni',
        close_menu: 'Zapri meni',
    },
    color_mode: {
        switch_to_light: 'Preklopi na svetlo temo',
        switch_to_dark:  'Preklopi na temno temo',
    },
    nav: {
        home:         'Domov',
        workspaces:   'Delovna okolja',
        settings:     'Nastavitve',
        admin:        'Administracija',
        host:         'Gostitelj',
        environments: 'Okolja',
        hostnames:    'Javni naslovi',
        tls:          'TLS',
        users:        'Uporabniki',
        audit:        'Dnevnik dogodkov',
        platform:     'Platforma',
        logout:       'Odjava',
    },
    login: {
        title:        'Prijava v Startbox',
        subtitle:     'Za nadaljevanje uporabite svoj GitLab račun.',
        sign_in:      'Prijava z GitLabom',
        failed:       'Prijava ni uspela. Poskusite znova.',
        signing_in:   'Prijavljanje…',
        // Kode `?error=`, s katerimi /auth/callback preusmeri nazaj na prijavo.
        error_state:    'Ta prijavna povezava ni več veljavna — odprta je bila dvakrat ali je predolgo čakala. Prijavite se znova.',
        error_exchange: 'GitLab te prijave ni potrdil. Prijavite se znova.',
        error_gitlab:   'GitLab ni bil dosegljiv za zaključek prijave. Poskusite znova v nekaj trenutkih.',
        error_session:  'Startbox prijave ni mogel zaključiti. Poskusite znova — če se ponavlja, obvestite skrbnika.',
    },
    home: {
        title:             'Domov',
        running:           'V teku',
        running_empty:     'Trenutno ne teče nobeno okolje.',
        see_all_workspaces: 'Vsa delovna okolja',
        groups_view:       'Skupine',
        projects_view:     'Projekti',
        refresh:           'Osveži iz GitLaba',
        refresh_success:   'Projekti so osveženi iz GitLaba',
        refresh_limited:   'Osveženo pred kratkim — počakajte trenutek pred naslednjim osveževanjem',
        search_placeholder: 'Iskanje projektov…',
        no_projects:       'Ni projektov',
        no_groups:         'Ni skupin',
        all_groups:        'Vse skupine',
        subgroups:         'Podskupine',
        projects:          'Projekti',
        project_count:     '{count} projektov',
        last_fetched:      'Nazadnje osveženo {time}',
        load_error:        'Seznama projektov ni bilo mogoče naložiti.',
        warming:           'Nalaganje vaših projektov iz GitLaba…',
        disk_warning:      'Strežniku zmanjkuje prostora na disku.',
        image_warning:     'Nove slike delovnega prostora ni bilo mogoče zgraditi.',
    },
    project: {
        default_branch:    'Privzeta veja',
        start:             'Zaženi',
        stop:              'Ustavi',
        reset:             'Ponastavi',
        delete:            'Izbriši',
        console:           'Konzola',
        open_workspace:    'Odpri delovno okolje',
        advanced:          'Napredno',
        never_started:     'Še ni zagnano',
        limits:            '{cpu} vCPU · {memory} RAM',
        last_heartbeat:    'Zadnji odziv {time}',
        read_only_warning: 'Ta projekt lahko samo berete, zato sprememb ni mogoče objaviti nazaj.',
        drift:             'Nastavitve spremenjene',
        drift_fix:         'Popravi',
        drift_fixed:       'Popravek je zahtevan — okolje ga bo kmalu izvedlo',
        delete_after:      'Izbrisano bo čez {count} dan | Izbrisano bo čez {count} dni',
        delete_after_soon: 'Izbrisano bo danes',
        state_message:     'Razlog: {message}',
        signin_title:      'Prijava v Claude',
        signin_open:       'Prijava v Claude',
        signin_code:       'Prijavna koda',
        signin_submit:     'Pošlji kodo',
        signin_sent:       'Koda je poslana v okolje',
        signin_waiting:    'Koda je poslana — čakamo na okolje (običajno 10 s)…',
        signin_typing:     'Prijavljanje v Claude…',
        signin_success:    'Prijava je uspela',
        signin_failed:     'Prijava ni uspela',
        signin_restart:    'Zahtevaj novo prijavno povezavo',
        signin_restarted:  'Zahtevana je nova prijavna povezava — kmalu se prikaže tukaj',
        confirm_stop:      'Ustavim ta delovni prostor? Vaše delo se prej shrani.',
        confirm_reset:     'Zgradim ta delovni prostor znova? Vaše delo se prej shrani.',
        confirm_delete:    'Izbrišem ta delovni prostor? Vaše delo se prej shrani.',
        started:           'Okolje se zaganja',
        stopping:          'Okolje se ustavlja',
        resetting:         'Okolje se ponastavlja',
        deleting:          'Okolje se briše',
        deleted:           'Okolje je izbrisano',
        pending:           'Izvajanje…',
        state: {
            stopped:          'Ustavljeno',
            starting:         'Zaganjanje',
            needs_signin:     'Potrebna prijava',
            running:          'Teče',
            running_outdated: 'Teče',
            error:            'Težava',
        },
        update_available:  'Posodobitev se namesti ob naslednjem zagonu tega delovnega prostora.',
    },
    share: {
        auth_sso:      'Prijava z GitLabom',
        auth_pin:      'PIN',
        auth_password: 'Geslo',
        auth_none:     'Brez preverjanja',
    },
    backup: {
        title:          'Varnostne kopije ({count})',
        expires_in:     'poteče čez {count} dan | poteče čez {count} dni',
        expires_today:  'poteče danes',
        no_expiry:      'ohranjeno',
        restored:       'obnovljeno',
        keep:           'Obdrži',
        kept:           'Varnostna kopija bo ohranjena',
        deleted:        'Varnostna kopija je izbrisana',
        confirm_delete: 'Izbrišem to varnostno kopijo? Ni je mogoče povrniti.',
        warn_count:     '{count} varnostna kopija bo kmalu odstranjena | {count} varnostnih kopij bo kmalu odstranjenih',
    },
    access: {
        only_me:              'Samo vi',
        people:               'Določeni ljudje',
        company:              'Vsi v podjetju',
        link:                 'Vsi s povezavo',
        pin:                  'S PIN-om',
        password:             'Z geslom',
        add_person:           'Dodaj osebo…',
        pin_placeholder:      '4–12 številk',
        password_placeholder: 'Vsaj 8 znakov',
        keep:                 'Obdrži',
        no_expiry:            'Ne poteče',
        expires_in:           'Poteče čez {hours} h',
        remove_link:          'Odstrani povezavo',
        workspace_people:     'Ljudje z dostopom',
    },
    environment: {
        title:               'Delovni prostor',
        list_title:          'Vaši delovni prostori',
        list_empty:          'Delovnih prostorov še ni.',
        activity:            'Zadnja dejavnost',
        active_since:        'Dejavno {time}',
        stopped_ago:         'Ustavljeno {time}',
        available_in_claude: 'Na voljo v Claude',
        owned_by:            'Lastnik: {user}',
        app_count:           '{count} aplikacij',
        instance:            'Instanca',
        dirty:               'Neshranjene spremembe',
        last_backup:         'Zadnja varnostna kopija',
        limits:              'Omejitve',
        volumes:             'Nosilci',
        volumes_value:       'Delovni prostor {ws} · Domači {home}',
        last_heartbeat:      'Zadnji odziv',
        plugins:             'Vtičniki',
        plugins_value:       'Vtičniki: {list}',
        docker_prune_value:  'Čiščenje Dockerja: {bytes} sproščeno {when}',
        state_message:       'Sporočilo stanja',
        apps:                 'Aplikacije v teku',
        apps_empty:           'Nič ne teče',
        apps_stopped:         'Delovni prostor ne teče',
        apps_stale:           'Ne teče',
        usage: {
            cpu:           'CPU',
            ram:           'RAM',
            workspace:     'Delovni prostor',
            home:          'Domači',
            cores:         '{count} vCPU',
            system:        'Sistem',
            disk:          'Disk',
            network_total: 'skupaj {rx} / {tx}',
        },
        metrics: {
            title:   'Poraba',
            network: 'Omrežje',
            used:    'Porabljeno',
            limit:   'Omejitev',
            rx:      'Prejeto',
            tx:      'Poslano',
        },
    },
    console: {
        title:        'Konzola',
        connecting:   'Povezovanje…',
        connected:    'Povezano',
        closed:       'Povezava je bila zaprta.',
        error:        'Povezava ni uspela.',
        reconnect:    'Ponovno poveži',
        not_running:  'Za odprtje konzole mora biti delovni prostor zagnan.',
    },
    changes: {
        title:         'Spremembe',
        files_changed: 'Spremenjenih datotek: {count}',
        staged:        'Pripravljeno',
        binary:        'Binarna datoteka',
        clean:         'Ni sprememb',
        not_running:   'Za branje sprememb mora biti delovni prostor zagnan.',
        load_failed:   'Sprememb ni bilo mogoče naložiti',
        download:      'Prenesi celotno razliko',
    },
    files: {
        title:          'Datoteke',
        root:           'Delovni prostor',
        empty:          'Prazna mapa',
        not_running:    'Za brskanje po datotekah mora biti delovni prostor zagnan.',
        truncated:      'Prikazanih je le prvih 500 vnosov.',
        upload:         'Naloži',
        upload_success: 'Naložena {count} datoteka | Naloženih {count} datotek',
        upload_failed:  'Datoteke ni bilo mogoče naložiti.',
        download:       'Prenesi',
        copy_path:      'Kopiraj pot',
        too_large:      'Ta datoteka je prevelika za predogled.',
        no_preview:     'Te datoteke ni mogoče predogledati.',
        preview_failed: 'Datoteke ni bilo mogoče odpreti.',
        load_failed:    'Mape ni bilo mogoče odpreti',
    },
    settings: {
        title:        'Nastavitve',
        appearance:   'Videz',
        color_mode:   'Tema',
        language:     'Jezik',
        language_en:  'English',
        language_sl:  'Slovenščina',
        home_view:    'Privzeti pogled domače strani',
        home_groups:  'Skupine',
        home_projects: 'Projekti',
        saved:        'Nastavitve so shranjene',
        account:      'Račun',
        admin_badge:  'Administrator',
        netbird: {
            title:      'Zasebno omrežje',
            linked:     'Vaš račun NetBird je povezan',
            not_linked: 'Vaš račun NetBird še ni povezan',
        },
        ssh_key: {
            title: 'Ključ SSH',
        },
    },
    claude_account: {
        title:            'Računi Claude',
        add:              'Dodaj račun',
        label:            'Ime',
        default:          'Privzeti',
        set_default:      'Uporabi privzeto',
        rename:           'Preimenuj',
        empty:            'Ni še računov.',
        start_with:       'Zaženi z',
        one:              'Račun Claude',
        confirm_delete:   'Odstranim {label}?',
        name_taken:       'To ime je že uporabljeno',
        deleted:          'Račun je odstranjen',
        delete_conflict:  'Tega računa ni mogoče odstraniti — najprej nastavite drug račun kot privzeti',
    },
    instance_type: {
        title:         'Vrsta strežnika',
        choose:        'Izberite vrsto strežnika',
        start_title:   'Zaženi delovni prostor',
        change:        'Zamenjaj vrsto strežnika',
        summary:       '{cpu} vCPU · {memory} · {ws}',
        changed:       'Vrsta strežnika je zamenjana',
        limit_reached: 'Ta vrsta strežnika je že polna',
        kvm:           'KVM',
        no_kvm:        'Brez KVM',
        kvm_note:      'Ta delovni prostor lahko poganja virtualne stroje in emulatorje.',
    },
    image: {
        preparing: 'Pripravljanje slike delovnega prostora',
        step: {
            create_instance: 'Pripravljanje gradbenega okolja',
            install_tools:   'Nameščanje gradbenih orodij',
            push_inputs:     'Prenašanje recepta',
            build:           'Gradnja slike',
            pull:            'Prevzemanje slike',
            import:          'Uvažanje slike',
            smoke_test:      'Preizkusni zagon slike',
            verify:          'Preverjanje slike',
            swap:            'Preklop na novo sliko',
            cleanup:         'Pospravljanje',
        },
        status: {
            none:      'Slike še ni',
            building:  'Gradnja',
            succeeded: 'Pripravljena',
            failed:    'Gradnja ni uspela',
            skipped:   'Gradnja je bila preskočena',
        },
    },
    admin: {
        title:              'Administracija',
        settings:           'Nastavitve instance',
        audit:              'Dnevnik dogodkov',
        host: {
            title:             'Stanje gostitelja',
            incus_reachable:   'Incus je dosegljiv',
            incus_unreachable: 'Incus ni dosegljiv',
            incus_version:     'Incus {version}',
            ram:               'RAM',
            pool:              'Diskovni bazen',
            cpu:               'CPU',
            usage:             'Porabljeno {used} od {total}',
            free:              'Prosto {free}',
            cores:             '{count} vCPU',
            load:              'Obremenitev {load}',
            running:           'Delujoča okolja',
            kvm:               'Virtualizacija',
            kvm_available:     'Na voljo',
            kvm_unavailable:   'Ni na voljo',
            committed:         'Obljubljene kvote',
            committed_limit:   'Zgornja meja prekoračitve',
            overcommit:        'Faktor prekoračitve',
            footprint:         'Odtis novega delovnega prostora',
            headroom:          'Rezerva na disku',
            critical:          'Kritično pod',
            pressure_low:      'Malo prostora na disku',
            pressure_critical: 'Kritično malo prostora na disku',
            checked:           'Preverjeno {time}',
            load_error:        'Stanja gostitelja ni bilo mogoče naložiti.',
            metrics_title:     'Poraba',
            metrics_used:      'Porabljeno',
            metrics_total:     'Skupaj',
            load_title:        'Obremenitev',
            load_1:            '1 min',
            load_5:            '5 min',
            load_15:           '15 min',
        },
        environments: {
            open:           'Odpri delovno okolje',
            state:          'Stanje',
            user:           'Uporabnik',
            search:         'Iskanje',
            last_heartbeat: 'Zadnji odziv',
            no_items:       'Ni okolij.',
            total_ram:      'RAM v uporabi',
            total_disk:     'Zaseden disk',
            running_count:  'Zagnanih: {count}',
        },
        users: {
            username:          'Uporabniško ime',
            email:             'E-pošta',
            environments:      'Okolja',
            last_login:        'Zadnja prijava',
            limits:            'Omejitve',
            limits_default:    'Privzete',
            limits_title:      'Omejitve za {user}',
            custom_home:       'Domači nosilec po meri',
            home:              'Domači nosilec (GB)',
            types:             'Vrste strežnikov',
            types_title:       'Vrste strežnikov za {user}',
            types_default:     'Privzeto',
            types_is_default:  'Privzeta',
            types_max_running: 'Hkratnih delovnih prostorov',
            types_saved:       'Vrste strežnikov so shranjene',
            cleared:           'Nastavitev po meri je odstranjena',
            saved:             'Omejitve so shranjene',
            no_users:          'Ni uporabnikov.',
            admin:             'Administrator',
        },
        instance_types: {
            title:          'Vrste strežnikov',
            add:            'Dodaj vrsto strežnika',
            edit_title:     'Urejanje vrste strežnika',
            name:           'Ime',
            cpu:            'vCPU',
            memory:         'RAM (GB)',
            ws:             'Delovni prostor (GB)',
            max_running:    'Hkratnih delovnih prostorov',
            unlimited:      'Neomejeno',
            default:        'Privzeta',
            set_default:    'Nastavi kot privzeto',
            no_items:       'Ni vrst strežnikov.',
            in_use:         'Ta vrsta strežnika je v uporabi in je ni mogoče izbrisati',
            saved:          'Vrsta strežnika je shranjena',
            deleted:        'Vrsta strežnika je izbrisana',
            confirm_delete: 'Izbrišem {name}?',
            apply_failed:   'Nove velikosti ni bilo mogoče uveljaviti pri {count} delujočem delovnem prostoru | Nove velikosti ni bilo mogoče uveljaviti pri {count} delujočih delovnih prostorih',
            name_taken:     'To ime je že uporabljeno',
        },
        settings_form: {
            defaults:                  'Privzete vrednosti okolja',
            retention:                 'Hramba',
            exposure:                  'Privzete vrednosti deljenja',
            language:                  'Jezik',
            home:                      'Domači nosilec (GB)',
            idle_stop_hours:           'Ustavi nedejavna okolja po (urah)',
            auto_delete_days:          'Izbriši ustavljena okolja po (dneh)',
            backup_branch_keep:        'Število varnostnih vej na projekt',
            home_export_keep:          'Število varnostnih kopij doma na uporabnika',
            exposure_auth:             'Privzeto preverjanje pristnosti za javne povezave',
            exposure_ttl:              'Javne povezave potečejo po (urah)',
            hostname_pool_mode:        'Način javnih naslovov',
            hostname_pool_target:      'Število prostih javnih naslovov v pripravljenosti',
            default_language:          'Privzeti jezik vmesnika',
            claude_code:               'Claude Code',
            claude_code_auto_update:   'Posodobi Claude Code ob zagonu okolja',
            saved:                     'Nastavitve so shranjene',
        },
        plugins: {
            title:              'Vtičniki Claude Code',
            marketplaces:       'Tržnice',
            add_marketplace:    'Dodaj tržnico',
            name:               'Ime',
            source:             'Vir',
            source_git:         'Repozitorij Git',
            source_github:      'Repozitorij GitHub',
            source_url:         'Neposreden naslov marketplace.json',
            url:                'Naslov',
            repo:               'Repozitorij (lastnik/repozitorij)',
            enabled:            'Omogočeni vtičniki',
            enabled_placeholder: 'Izberite ali vpišite vticnik{\'@\'}trznica',
            fetch_failed:       'Tržnice ni bilo mogoče prebrati',
            enforcement:        'Uveljavljanje',
            enforce:            'Uveljavi to politiko',
            invalid_name:       'Dovoljene so le črke, številke, pike, pomišljaji in podčrtaji.',
            invalid_url:        'To se ne ujema z izbranim virom: GitHub pričakuje lastnik/repozitorij, neposreden naslov pričakuje https://, vir git pa naslov HTTPS ali git{\'@\'}streznik:pot.git.',
            reserved_name:      'To ime pripada eni od Anthropicovih lastnih tržnic; vtičniki z nje tu ne potrebujejo vnosa.',
            invalid_plugin:     'Vtičnik zapišite kot vticnik{\'@\'}trznica.',
            saved:              'Politika vtičnikov je shranjena',
        },
        hostnames: {
            title:            'Javni naslovi',
            manage:           'Upravljanje naslovov',
            on_demand:        'Naslovi se ustvarijo po potrebi',
            hostname:         'Naslov',
            source:           'Vir',
            source_generated: 'Samodejno ustvarjen',
            source_manual:    'Ročno vnesen',
            mode:             'Način naslovov te namestitve',
            add:              'Dodaj naslove',
            add_label:        'Naslovi',
            add_placeholder:  'demo.example.com\napp.example.com',
            created:          'Dodanih: {count}',
            result_created:   'Dodano',
            result_errors:    'Zavrnjeno',
            state:            'Stanje',
            exposure:         'Uporablja',
            assigned:         'Dodeljen',
            cooldown:         'Mirovanje se konča',
            last_auth:        'Zadnja overitev',
            target:           'Ciljno število prostih',
            created_last_7d:  'Ustvarjenih v zadnjih 7 dneh',
            weekly_budget:    'Tedenska omejitev',
            state_free:       'Prost',
            state_assigned:   'V uporabi',
            state_reserved:   'Rezerviran',
            state_cooling:    'V mirovanju',
            release:          'Sprosti',
            release_confirm:  'Ali želite sprostiti {name}? Ne bo več hranjen za {owner}, šel bo v mirovanje in nato lahko pripade komu drugemu.',
            released:         'Naslov je sproščen',
            retire:           'Umakni',
            retire_confirm:   'Ali želite umakniti {name}? Trajno bo odstranjen iz bazena in ne bo nikoli več dodeljen.',
            retired:          'Naslov je umaknjen',
            no_items:         'Ni naslovov.',
        },
        tls: {
            title:                    'TLS in potrdila',
            manage:                   'Upravljanje TLS',
            settings:                 'Nastavitve TLS',
            certificates:             'Potrdila',
            load_error:               'Nastavitev TLS ni bilo mogoče naložiti.',
            saved:                    'Nastavitve TLS so shranjene',
            mode:                     'Način TLS',
            mode_external:            'Zaključen pred panelom',
            mode_panel:               'Zaključi ga panel',
            cert_mode:                'Način potrdil',
            cert_per_hostname:        'Eno potrdilo na naslov',
            cert_wildcard_acme:       'Nadomestno potrdilo prek DNS-01',
            cert_wildcard_files:      'Nadomestno potrdilo, ki ga naložite',
            wildcard_files_missing:   'Naložiti je treba nadomestno potrdilo',
            acme:                     'Račun ACME',
            acme_email:               'E-pošta računa',
            directory:                'Imenik',
            directory_production:     'Let’s Encrypt – produkcija',
            directory_staging:        'Let’s Encrypt – testno okolje',
            directory_custom:         'Imenik po meri',
            directory_url:            'URL imenika',
            directory_url_invalid:    'Vnesite naslov https:// imenika ACME',
            dns:                      'Izziv DNS-01',
            dns_provider:             'Ponudnik DNS',
            dns_provider_none:        'Brez',
            dns_provider_httpreq:     'httpreq (zahteva HTTP)',
            dns_provider_required:    'Nadomestno potrdilo prek DNS-01 potrebuje ponudnika DNS',
            dns_config:               'Nastavitve ponudnika',
            dns_config_key:           'Ključ',
            dns_config_value:         'Vrednost',
            dns_config_masked:        'Skrito — vpišite za zamenjavo',
            dns_config_add:           'Dodaj nastavitev',
            dns_config_remove:        'Odstrani',
            dns_config_restore:       'Ohrani',
            dns_config_empty:         'Nastavitev ponudnika še ni.',
            plane_host:               'Naslov panela',
            summary_valid:            'Veljavna',
            summary_pending:          'V teku',
            summary_error:            'Neuspela',
            summary_expiring:         'Potečejo v 30 dneh',
            name:                     'Glavni naslov',
            names:                    'Naslovi',
            kind:                     'Vrsta',
            kind_acme:                'ACME',
            kind_uploaded:            'Naloženo',
            kind_self_signed:         'Samopodpisano',
            status_valid:             'Veljavno',
            status_pending:           'V teku',
            status_error:             'Neuspelo',
            expires:                  'Poteče',
            issued:                   'Izdano',
            next_attempt:             'Naslednji poskus {time}',
            last_error:               'Zadnja napaka',
            renew:                    'Obnovi',
            renew_confirm:            'Ali naj zdaj obnovim potrdilo za {name}? Overitelj potrdil vsako naročilo šteje v omejitev.',
            renew_requested:          'Obnovitev je zahtevana',
            renew_only_acme:          'Obnoviti je mogoče samo potrdilo, ki ga je naročil panel',
            wildcard_needs_generated: 'Nadomestno potrdilo pokriva samo generirane naslove — najprej zamenjajte način potrdil ali uporabite potrdilo na ime',
            delete_confirm:           'Ali želite izbrisati naloženo potrdilo za {name}? Takoj se preneha streči.',
            deleted:                  'Potrdilo je izbrisano',
            delete_conflict:          'Izbrisati je mogoče le naloženo potrdilo — ostala upravlja panel sam.',
            delete_only_uploaded:     'Izbrisati je mogoče le naloženo potrdilo',
            upload:                   'Naloži potrdilo',
            upload_cert:              'Veriga potrdil (PEM)',
            upload_cert_placeholder:  '-----BEGIN CERTIFICATE-----',
            upload_key:               'Zasebni ključ (PEM)',
            upload_key_placeholder:   '-----BEGIN PRIVATE KEY-----',
            upload_invalid:           'To ni videti kot PEM — začeti se mora z -----BEGIN',
            uploaded:                 'Potrdilo je naloženo',
            no_items:                 'Ni potrdil.',
        },
        netbird: {
            title:       'NetBird',
            reachable:   'Upravljanje je dosegljivo',
            unreachable: 'Upravljanje ni dosegljivo',
            peers:       'Vozlišča',
            checked:     'Preverjeno {time}',
            disabled:    'NetBird je na tej namestitvi onemogočen',
        },
        image: {
            title:          'Slika delovnega prostora',
            built:          'Zgrajena',
            agent_version:  'Agent',
            claude_version: 'Claude Code',
            previous:       'Prejšnja',
            no_image:       'Slika še ni bila zgrajena',
            build:          'Zgradi novo',
            build_started:  'Gradnja slike se je začela',
            revert:         'Povrni na prejšnjo sliko',
            revert_confirm: 'Povrnem na sliko {version}?',
            reverted:       'Prejšnja slika je znova v uporabi',
            failed:         'Zadnja gradnja ni uspela',
            skipped:        'Zadnja gradnja je bila preskočena',
            log:            'Dnevnik',
            log_title:      'Dnevnik gradnje',
            log_empty:      'Gradnja ni pustila dnevnika',
            truncated:      'Ohranjen je samo konec dnevnika',
        },
        audit_log: {
            at:      'Čas',
            actor:   'Izvajalec',
            action:  'Dejanje',
            target:  'Cilj',
            ip:      'IP',
            details: 'Podrobnosti',
            from:    'Od',
            to:      'Do',
            no_events: 'Ni dogodkov.',
        },
    },
    create: {
        new_project:       'Nov projekt',
        new_group:         'Nova skupina',
        name:              'Ime',
        location:          'Lokacija',
        parent:            'Nadrejena skupina',
        top_level:         'Brez nadrejene skupine',
        personal:          'Osebno',
        create:            'Ustvari',
        create_group:      'Ustvari skupino',
        created:           'Projekt je ustvarjen',
        group_created:     'Skupina je ustvarjena',
        nowhere:           'V GitLabu ne morete ustvariti nobenega projekta. Obrnite se na skrbnika GitLaba.',
        project_forbidden: 'Tukaj ne morete ustvariti projekta.',
        group_forbidden:   'Tukaj ne morete ustvariti skupine.',
        name_taken:        'To ime je tukaj že zasedeno.',
        name_invalid:      'Uporabite črke, številke, presledke, pike, vezaje ali podčrtaje.',
        open_gitlab:       'Odpri v GitLabu',
    },
    starter: {
        button: 'Začetni poziv',
        prompt: 'Delam v Startboxu ({startbox_url}). Vsak moj projekt je v GitLabu ({gitlab_url}) in ima svoje delovno okolje s Claude Code, do katerega dostopam iz aplikacije Claude. Nisem razvijalec: tehnično delo opravi namesto mene in mi razloži samo tisto, o čemer moram odločiti sam. Želim ',
    },
    guide: {
        title:         'Navodila',
        heading:       'Delo s Startboxom',
        download_pdf:  'Prenesi PDF',
        preview:       'Predogled',
        client_name:   'Ime naročnika',
        contact:       'Kontakt',
        contact_hint:  'Koga vprašati za pomoč: ime, e-pošta, telefon',
        starter_title: 'Začetni poziv',
        help_title:    'Pomoč',
        sign_in: {
            title: 'Prijava',
            open:  'Odprite {url}',
            press: 'Pritisnite »Prijava z GitLabom« in uporabite svoj račun GitLab ({url}).',
        },
        start: {
            title:  'Zagon projekta',
            find:   'Na strani Domov poiščite svoj projekt — ali pritisnite »Nov projekt« in ga ustvarite.',
            press:  'Pritisnite »Zaženi«. Delovno okolje je pripravljeno v približno minuti.',
            claude: 'Samo prvič: pritisnite »Prijava v Claude«, se prijavite s svojim računom Claude in kodo, ki se prikaže, prilepite v Startbox.',
        },
        connect: {
            title:   'Povezava s Claude',
            install: 'Namestite aplikacijo Claude na računalnik ali telefon in se prijavite z istim računom Claude.',
            open:    'V aplikaciji Claude odprite »Code«. Vaše delovno okolje je navedeno pod imenom projekta.',
            ready:   'Ko projekt na strani Domov kaže »Na voljo v Claude«, Claudu povejte, kaj želite.',
        },
        where: {
            title:      'Kje je kaj',
            workspaces: '»Delovna okolja« prikaže vsa vaša delovna okolja.',
            apps:       '»Aplikacije v teku« v delovnem okolju prikaže, kar je zgradil Claude; »Odpri« to odpre v brskalniku.',
            files:      '»Datoteke« omogoča pregledovanje, prenos in nalaganje datotek.',
            changes:    '»Spremembe« prikaže, kaj je Claude spremenil v projektu.',
            gitlab:     'Vaše delo je shranjeno v GitLabu ({url}).',
        },
        done: {
            title: 'Ko končate',
            stop:  'Pritisnite »Ustavi« ali pa ga pustite: neuporabljeno delovno okolje se ustavi samo. Vaše delo se prej shrani.',
        },
    },
    not_found: {
        title:    'Strani ni mogoče najti',
        subtitle: 'Stran, ki jo iščete, ne obstaja.',
        home:     'Nazaj na domačo stran',
    },
}
